<template>
    <v-container class="pa-2">
        <v-row dense>
            <v-col cols="12">

                <!-- Header sticky -->
                <v-card class="rounded-xl elevation-2 px-3 py-3 mb-3 sticky-header">
                    <div class="d-flex align-center">
                        <div class="schema-num-wrap mr-3 flex-shrink-0">
                            <span class="schema-num">{{ discorso.diId }}</span>
                        </div>
                        <div class="flex-grow-1" style="min-width:0">
                            <div class="text-subtitle-2 font-weight-bold primary--text" style="line-height:1.3">
                                {{ discorso.tema }}
                            </div>
                            <div class="text-caption grey--text mt-1">
                                {{ oratori.length }} orator{{ oratori.length === 1 ? 'e' : 'i' }}
                            </div>
                        </div>
                    </div>
                </v-card>

                <!-- Skeleton -->
                <template v-if="loading">
                    <v-card v-for="n in 5" :key="n" class="rounded-xl elevation-1 mb-2 px-3 py-2">
                        <v-skeleton-loader type="list-item-avatar-two-line" />
                    </v-card>
                </template>

                <!-- Lista oratori -->
                <template v-else>
                    <div v-if="oratori.length === 0" class="text-center grey--text py-10">
                        <v-icon large color="grey lighten-1">mdi-account-off-outline</v-icon>
                        <div class="mt-2 text-body-2">Nessun oratore assegnato</div>
                    </div>

                    <v-card v-for="oratore in oratori" :key="oratore.id"
                            class="rounded-xl elevation-1 mb-2">
                        <div class="d-flex align-center px-3 py-2">
                            <v-avatar size="40" color="primary" class="mr-3 flex-shrink-0">
                                <span class="white--text" style="font-size:0.65rem;font-weight:700">
                                    {{ (oratore.nome ? oratore.nome[0] : '') + (oratore.cognome ? oratore.cognome[0] : '') }}
                                </span>
                            </v-avatar>
                            <div class="flex-grow-1" style="min-width:0">
                                <div class="d-flex align-center flex-wrap" style="gap:3px">
                                    <span class="text-body-2 font-weight-bold">{{ oratore.nome }} {{ oratore.cognome }}</span>
                                    <v-chip v-if="oratore.isAnziano"      x-small dark color="teal">A</v-chip>
                                    <v-chip v-if="oratore.isSM"           x-small dark color="blue darken-1">SM</v-chip>
                                    <v-chip v-if="oratore.isAssistente"   x-small dark color="grey darken-2">ASSISTENTE</v-chip>
                                    <v-chip v-if="oratore.isCoordinatore" x-small dark color="deep-orange darken-4">ADM</v-chip>
                                    <v-chip v-if="oratore.isAdmin"        x-small dark color="orange darken-1">APP-ADM</v-chip>
                                    <chip-login-oratore :oratore="oratore" />
                                </div>
                                <div class="text-caption grey--text">{{ oratore.congregazione && oratore.congregazione.nome }}</div>
                                <div v-if="oratore.telefono"
                                     class="text-caption grey--text contact-link d-inline-flex align-center"
                                     style="cursor:pointer"
                                     @click.stop="openTel(oratore.telefono)">
                                    <v-icon x-small color="primary" class="mr-1">mdi-phone-outline</v-icon>{{ oratore.telefono }}
                                </div>
                            </div>
                        </div>
                    </v-card>
                </template>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { callService } from '@/modules/utilities.js'
import ChipLoginOratore from '@/components/ChipLoginOratore.vue'

export default {
    components: { ChipLoginOratore },
    props: {
        discorso: { type: Object, required: true },
    },
    data: () => ({
        oratori: [],
        loading: false,
    }),
    watch: {
        discorso(newVal) {
            if (newVal && newVal.id) this.fetchOratori(newVal.id);
        }
    },
    methods: {
        openTel(tel) {
            if (tel) this.$openUrl('tel:' + tel.replace(/\s/g, ''));
        },
        async fetchOratori(idDiscorso) {
            this.loading = true;
            this.oratori = [];
            const param = [this.$store.state.idCircoscrizione, idDiscorso];
            const oratidiscorso = await callService('/api/oratore/oratidiscorso', param);
            this.oratori = oratidiscorso.map(od => od.oratore);
            this.loading = false;
        }
    },
    mounted() {
        if (this.discorso && this.discorso.id) this.fetchOratori(this.discorso.id);
    }
}
</script>

<style scoped>
.sticky-header {
    position: sticky;
    top: 0;
    z-index: 4;
}
.schema-num-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    flex-shrink: 0;
}
.schema-num {
    font-size: 0.78rem;
    font-weight: 800;
    color: #fff;
    letter-spacing: -0.02em;
}
.theme--dark .schema-num-wrap {
    background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
}
</style>
